import React, { useCallback, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import { Container, Button } from './styles';

const Menu: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleOpenMenu = useCallback(() => {
    setOpen(!open);
  }, [open]);

  return (
    <>
      <Button type="button" onClick={handleOpenMenu}>
        <span />
        <span />
      </Button>

      <SwitchTransition mode={open ? 'in-out' : 'out-in'}>
        <CSSTransition
          key={Number(open)}
          addEndListener={(node, done) => {
            node.addEventListener('transitionend', done, false);
          }}
          classNames="fade-modal"
        >
          {open ? (
            <Container>
              <div className="content">
                <div className="menu-list">
                  <NavLink activeClassName="active" exact to="/">
                    HomePage
                  </NavLink>
                  <NavLink activeClassName="active" to="/about">
                    About Us
                  </NavLink>
                  <NavLink activeClassName="active" to="/contact">
                    Contact
                  </NavLink>
                </div>
                <div className="footer">
                  <div className="social">
                    <h4>Social Links</h4>
                    <ul>
                      <a
                        href="https://www.linkedin.com/in/mnzs/"
                        target="blank"
                      >
                        Linkedin
                      </a>
                      <a href="https://www.github.com/mnzsss" target="blank">
                        Github
                      </a>
                      <a href="mailto:job@mnzs.dev">E-mail</a>
                    </ul>
                  </div>
                </div>
              </div>
            </Container>
          ) : (
            <></>
          )}
        </CSSTransition>
      </SwitchTransition>
    </>
  );
};

export default Menu;
